<template>
    <div v-show="show" class="resume-select">
        <div class="resume-select-active-block"></div>
        <Scroller
            :snapping="snapping"
            :size="size"
            :position-y="positionY"
            :auto-resize="false"
            @on-scrollend="scrollEnd"
        >
            <ul :id="containerId" class="resume-select-ul">
                <li v-for="(item, index) in list" :key="index" class="resume-select-li">{{ item.text }}</li>
            </ul>
        </Scroller>
    </div>
</template>
<script>
import Scroller from '@/components/Scroller';
export default {
    name: 'Select',
    components: {Scroller},
    props: {
        snapping: {
            type: Boolean,
            default: true
        },
        dataList: {
            type: Array,
            default: () => []
        },
        selectedIndex: {
            type: Number,
            default: 0
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            containerId: `resume-ul-${
                Math.random()
                    .toString(36)
                    .substring(3, 10)}`,
            container: undefined,
            // list: ['', ''].concat(this.dataList, ['', '']),
            // list: this.dataList,
            positionY: 0,
            snapHeight: 1,
            firstShow: true // 只有初始化展示进行定位，后面滚动之后的定位不再进行定位计算
        };
    },
    computed: {
        list() {
            return [{}, {}].concat(this.dataList, [{}, {}]);
        },
        size() {
            return this.list.length;
        }
    },
    watch: {
        show: {
            handler(val) {
                if (val) {
                // 初始化滚动行高及初始化位置
                    if (this.snapping && this.snapHeight === 1) {
                        this.$nextTick(() => {
                            this.container = document.getElementById(this.containerId);
                            this.snapHeight = this.container.offsetHeight / this.list.length;
                            this.positionY = this.snapHeight * this.selectedIndex;
                            console.log(this.container, this.snapHeight, this.positionY);
                        });
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        scrollEnd(position) {
            // 只存下展示时位置
            if (this.show) {
                const top = position.top;
                const selectedIndex = Math.round(top / this.snapHeight); // 滚动停止之后滚动距离顶部的个数
                this.$emit('on-scrollend', this.dataList[selectedIndex] || {}, selectedIndex);
            }
        }
    }
};

</script>
